import { ReactNode } from 'react'
import Icon from '@/components/icon'
import { smoothScroll } from '@/utils/dom.ts'
import { cx, slugify } from '@/utils/strings.js'
import type { InspectorTags } from '@/utils/live-preview'

export type SizeType = 'h2' | 'h3'

export default function HeadingWithAnchor({
  id,
  type,
  title,
  className,
  offset,
  ...rest
}: Readonly<{
  id?: string
  type: SizeType
  title: string
  className?: string
  offset?: number
}> &
  InspectorTags) {
  const anchor = slugify(id ?? title)
  return (
    <div id={anchor} className={cx(`scrollspy group inline-block w-full relative`)} {...rest}>
      <a
        title={`#${anchor}`}
        href={`#${anchor}`}
        onClick={(event) => {
          event.preventDefault()
          const { origin, pathname } = window.location
          smoothScroll(event, offset ?? 0)
          navigator.clipboard.writeText(`${origin}${pathname}#${anchor}`)
        }}
        className={cx(
          'absolute text-primaryBlue opacity-0 group-hover:opacity-40 hover:opacity-100 transition-opacity duration-150 -left-[1.1em]',
          type === 'h2' && 'text-2xl top-4',
          type === 'h3' && 'text-xl top-3'
        )}
      >
        <span className="bwi bwi-hashtag" />
      </a>
      <Heading type={type} className={className}>
        {title}
      </Heading>
    </div>
  )
}

function Heading({ type, children, className }: Readonly<{ type: SizeType; children: ReactNode; className?: string }>) {
  if (type === 'h2') return <h2 className={className}>{children}</h2>
  if (type === 'h3') return <h3 className={className}>{children}</h3>
}
